import Application from "../../Application";
import { ILegalView } from "../model/LegalView";
import { ILegalViewService } from "../service/LegalViewService";

export default class UpdateLegalViewInteractor {
  private application: Application;
  private legalViewService: ILegalViewService;

  constructor({ application, legalViewService }: any) {
    this.application = application;
    this.legalViewService = legalViewService;
  }

  async execute(item: ILegalView, indexes: number[]) {
    return this.legalViewService.updateLegalView(item, indexes);
  }
}
